export function createAnchors() {
  $('main h1, main h2, main h3, main h4, main h5, main h6').each(function() {
    const text = $(this)
      .text()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9 ]/g, '')
      .replace(/\s+/g, '-')
    if($('a[data-link="'+text+'"]').length) {
      $(this).closest('section').attr('data-anchor', text)
    }
  })
}

export function monitorAnchors() {
  const sections = document.querySelectorAll("[data-anchor]");
  const $navlist = $('.navigation__anchors');
  if($navlist.length) {
    for (let i = 0; i < sections.length; i++) {
      const observer = new IntersectionObserver((entry) => {
        if (entry[0].isIntersecting) {
          const anchor = sections[i].getAttribute('data-anchor');
          const remove = document.querySelector('.navigation__anchors a.current')
          const add = document.querySelector('.navigation__anchors li a[data-link="' + anchor + '"]')
          //if(typeof(remove) != 'undefined' && remove != null) { remove.removeAttribute("class") }
          if(typeof(add) != 'undefined' && add != null) {
            if(typeof(remove) != 'undefined' && remove != null) { remove.removeAttribute("class") }
            add.classList.add('current')
            const $navlink = $(add);
            const scrollpx = parseInt(Math.max(0, ($navlink.position().left + $navlist.scrollLeft() - ($navlist.width()/2) + ($navlink.width()/2)) ));
            $navlist.stop().animate({ scrollLeft: scrollpx }, 100)
          }
        }
      },{ rootMargin: "-50% 0px" });
      observer.observe(sections[i]);
    }
  }
}

export function scrollProgress() {
  const scrollProgress = document.querySelector('.navigation__progress');
  let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  if(scrollProgress) {
    window.addEventListener('resize', () => {
      height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    });

    window.addEventListener('scroll', () => {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      scrollProgress.style.setProperty('--progress', `${(scrollTop / height) * 100}%`);
    });
  }
}

export function scrollAnchors() {
  $('a[data-link]').click(function(e){
    e.preventDefault();
    const anchor = $(this).attr('data-link')
    scrollTo(anchor)
  })
  window.addEventListener('hashchange', function() {
    const hash = window.location.hash.replace('#', '')
    if(hash && $('[data-anchor="'+hash+'"]').length) { scrollTo(hash) }
  }, false);
  const hash = window.location.hash.replace('#', '')
  if(hash && $('[data-anchor="'+hash+'"]').length) {
    setTimeout(function(){ scrollTo(hash) }, 1200)
  }
}

function scrollTo(anchor) {
  const header = $('.header').outerHeight();
  $([document.documentElement, document.body]).animate({
    scrollTop: $('[data-anchor="'+anchor+'"]').offset().top - header - 100,
  }, 500);
}

export function shareLinks() {
  $('.share-buttons a:first-child').click(function(e){
    e.preventDefault();
    $(this).parent().addClass('open')
  })
}
